/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Project_TitleInputs */

const en_directory_api_reference_project_title = /** @type {(inputs: Directory_Api_Reference_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project API (Bearer token)`)
};

const zh_directory_api_reference_project_title = /** @type {(inputs: Directory_Api_Reference_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目 API（Bearer 令牌）`)
};

/**
* | output |
* | --- |
* | "Project API (Bearer token)" |
*
* @param {Directory_Api_Reference_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_project_title = /** @type {((inputs?: Directory_Api_Reference_Project_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Project_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_project_title(inputs)
	return zh_directory_api_reference_project_title(inputs)
});
export { directory_api_reference_project_title as "directory.api_reference.project_title" }